/* file description */

import React, { useEffect, useState, useRef } from 'react';
import { Button, Space, message, Drawer, Modal } from 'antd';
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import { ModuleInfo } from '@/common/model-apis/type';
import SpQiankun from '@/components/sp-qiankun';
import { CloseOutlined } from '@ant-design/icons';
import useMetaStore from '@/store/useMetaStore';


interface HeadAddButtonType {
  isHaveAdd?: boolean;
  taskId: string;
  utils: any;
  optionsActionType: string;
  reload: () => void;
  moduleInfo?: ModuleInfo;
}

const HeadAddButton: React.FC<HeadAddButtonType> = function (props) {
  const [open, setOpen] = useState(false);
  const [targetUrl, setTargetUrl] = useState('');
  const { taskId, isHaveAdd, optionsActionType, moduleInfo } = props;
  const meta = useMetaStore();
  const tabFrom = meta?.utils?.qiankun?.name ?? '';
  const addTableItem = () => {
    if (optionsActionType === 'drawer') {
      setTargetUrl(`/lcp/task/${taskId}/create`);
      setOpen(true);
      return;
    }

    props.utils?.buiNavigate({
      type: 'tab',
      path: `/lcp/task/${taskId}/create?TAB_KEY=${new Date().getTime()}&tabFrom=${tabFrom}`,
      title: 'EIMOS',
    });
  };
  const saveCb = (tag: boolean) => {
    if (tag) {
      props?.reload && props.reload();
      setOpen(false);
    }
  };


  return (
    <>
      <ButtonLayout type="primary" onClick={addTableItem}>
        新增
      </ButtonLayout>
      <Drawer
        contentWrapperStyle={{ minWidth: '40%' }}
        placement="right"
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        maskClosable={false}
      >
        <div style={{ position: 'absolute', right: 0, top: 0, padding: 12, zIndex: 9999, cursor: 'pointer' }} onClick={() => setOpen(false)}>
          <CloseOutlined />
        </div>
        <SpQiankun
          saveCb={saveCb}
          routeUrl={targetUrl}
          qiankun={meta?.utils?.qiankun}
        />
      </Drawer>
    </>
  );
};

export default HeadAddButton;
